import { useEffect } from "react"
import { useLocale } from "./locale-store"

export function LangAttributeSync() {
	const locale = useLocale()
	useEffect(() => {
		document.documentElement.lang = locale
	}, [locale])
	return null
}
